// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomEvent } from '@shared/utils/CustomEvents';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import { TerceraRadioButtonComponent, RadioButtonComponentEvents } from './TerceraRadioButtonComponent';
export class TerceraRadioComboItemGroup extends TerceraRadioButtonComponent {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.TerceraRadioComboItemGroup;
    }
    oninit() {
        super.oninit();
        this.SelectedValueChanged = new CustomEvent();
        this.on(RadioButtonComponentEvents.StateChange, this.onStateChanged);
    }
    onStateChanged(sender, selectedRBIdx) {
        this.SelectedValueChanged.Raise(this, this.get('radioItems')[selectedRBIdx].value);
    }
    setItems(selectedValue, items) {
        if (!isValidArray(items))
            return;
        const len = items.length;
        for (let i = 0; i < len; i++) {
            const item = items[i];
            if (item.value === selectedValue) {
                item.checked = true;
                break;
            }
        }
        void this.set('radioItems', items);
    }
}
TerceraRadioButtonComponent.extendWith(TerceraRadioComboItemGroup, {});
